import React from 'react';
import { Alert, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import usePermissions from '../../hooks/auth/usePermissions';
import useHistory from '../../hooks/navigation/useHistory';
import { ScreenEnum } from '../../hooks/navigation/Screens';

export default function NoFranchiseBanner() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Layout:NoFranchiseBanner' });
  const { company } = useSelector((state) => state.currentCompany);
  const { canAccessScreen } = usePermissions();
  const history = useHistory();

  if (!company?.id || company?.franchise_id || !canAccessScreen(ScreenEnum.Franchises)) {
    return null;
  }

  return (
    <Alert
      banner
      type="error"
      title={
        <div className="flex items-center justify-between">
          <span>{t('warning')}</span>
          <Button type="link" onClick={() => history.push(ScreenEnum.Franchises)}>
            {t('cta')}
          </Button>
        </div>
      }
    />
  );
}
